import React from 'react';
import {useAppStore} from "../../../../../../../GlobalStore/GlobalStore.ts";
import {clickFileLink} from "../../../../../../../Utils/misc/openLink.ts";
import {getDisplayCodeFileName} from "../../../Utils.ts";
import PdfLink from './PdfLink';
import DocxLink from './DocxLink';

interface CustomLinkProps {
    href?: string;
    children: React.ReactNode;
}

const CustomLink: React.FC<CustomLinkProps> = ({ href = '', children }) => {
    const classNameRegex = /^className,(.+)$/;
    const match = href?.match(classNameRegex);

    if (match) {
        const classes = match[1].split(',').filter(Boolean).join(' ');
        return <span className={classes}>{children}</span>;
    }

    const environmentObj = useAppStore((state: any) => state.environmentObj);
    const { environment, vscode } = environmentObj;
    const pattern = /^\[\d+]$/;

    if (!href || href.trim() === "") return <span>{children}</span>;

    // Handle document links
    const lowerHref = href.toLowerCase();
    if (lowerHref.endsWith('.pdf')) {
        return <PdfLink url={href}>{children}</PdfLink>;
    } else if (lowerHref.endsWith('.docx')) {
        return <DocxLink url={href}>{children}</DocxLink>;
    }

    if (pattern.test(children as string)) {
        return (
            <a
                className="text-blue-600 hover:text-blue-800 dark:text-blue-300 dark:hover:text-blue-200"
                href={href}
                onClick={(e) => clickFileLink(e, environment, vscode, href)}
            >
                <sup>{children}</sup>
            </a>
        );
    } else if ((environment.includes('jetbrains') || environment === "vscode") && !href.startsWith("http")) {
        const displayCodeFileName = getDisplayCodeFileName(href);
        return (
            <button
                onClick={(e) => clickFileLink(e, environment, vscode, href)}
                className={`inline-block border border-neutral-700 rounded px-2 py-1 bg-neutral-400 hover:bg-neutral-200 dark:bg-neutral-800 dark:hover:bg-neutral-900 cursor-pointer transition-colors duration-200 ${environment === "vscode" ? "text-xs" : "text-sm"}`}
            >
                <span className="mr-2">📄</span>
                {displayCodeFileName}
            </button>
        );
    } else {
        return (
            <a
                className="text-blue-600 dark:text-blue-300 hover:underline"
                href={href}
                onClick={(e) => clickFileLink(e, environment, vscode, href)}
            >
                {children}
            </a>
        );
    }
}

export default CustomLink;